module.exports = __webpack_public_path__ + "static/assets/b2df980c3862c0378684999d22d8acc1.png";